import React, { useContext, useEffect, useState } from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import AppContext from '@context';
import useAmplitude from '@hooks/useAmplitude';
import Error from './Error';
import Skeleton from './Skeleton';
import Item from './Item';
import Toogle from './Toogle';
import * as Styled from './ListStyles';

function List() {
  const { amplitudeEvent } = useAmplitude();
  const {
    state: {
      journeys: {
        selection: {
          data: dataSelection,
          historyEvents: { isFetching, isError, data },
        },
      },
    },
  } = useContext(AppContext);
  const maxHighlightLength = 4;
  const [isFullRender, setIsFullRender] = useState(false);
  const textButton = `Ver ${isFullRender ? 'menos' : 'mais'}`;

  useEffect(() => {
    if (data.length) {
      amplitudeEvent('journey_drawer_monitoring_events_history_show');
    }
  }, [data]);

  if (isFetching) {
    return <Skeleton />;
  }

  if (!dataSelection?.journey.id) {
    return null;
  }

  if (isError) {
    amplitudeEvent('journey_drawer_monitoring_events_history_error_show');
    return <Error journeyId={dataSelection.journey.id} />;
  }

  const historyHighlight = data.slice(0, maxHighlightLength);
  const historySeeMore = data.slice(maxHighlightLength, data.length);

  return (
    <Styled.Wrapper>
      {historyHighlight.map((item, index, array) => {
        return (
          <Item
            {...item}
            key={`modal-monitoring-history-event-${item.type}-${item.id}`}
            isFirstPrint={!isFullRender && index + 1 === array.length}
            isLastPrint={index === 0}
            journeyId={dataSelection.journey.id}
          />
        );
      })}
      <Toogle isShow={isFullRender}>
        {historySeeMore.map((item, index, array) => {
          return (
            <Item
              {...item}
              key={`modal-monitoring-history-event-${item.type}-${item.id}`}
              isFirstPrint={index + 1 === array.length}
              isLastPrint={false}
              journeyId={dataSelection.journey.id}
            />
          );
        })}
      </Toogle>
      {!!historySeeMore.length && (
        <FuelFlex defaultProps={{ justifyContent: 'center', margin: 'km3' }}>
          <FuelButton
            onClick={() => {
              setIsFullRender(!isFullRender);
              amplitudeEvent(
                'journey_drawer_monitoring_events_history_button_see_more_click',
                {
                  text: textButton,
                },
              );
            }}
            variant="tertiary"
            size="small"
          >
            {textButton}
          </FuelButton>
        </FuelFlex>
      )}
    </Styled.Wrapper>
  );
}

export default List;
